export default __webpack_public_path__ + "renoise.a479ab42.png";